import { render, staticRenderFns } from "./ListVehicles.vue?vue&type=template&id=3548a6e9&"
import script from "./ListVehicles.vue?vue&type=script&lang=js&"
export * from "./ListVehicles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports